import React from 'react';
import PropTypes from 'prop-types';

export const propertySettingsPropTypes = {
  createdAt: PropTypes.string,
  hideInternally: PropTypes.bool,
  showHideInternallyForStatuses: PropTypes.arrayOf(PropTypes.number).isRequired,
  updatedAt: PropTypes.string,
  syndication: PropTypes.bool.isRequired
};

class PropertySettings extends React.Component {
  static propTypes = {
    ...propertySettingsPropTypes
  }

  render() {
    return (
      <div className="property-settings">
        {this.renderHeader()}
        {this.renderSyndicationHiddenField()}
        {this.renderHideInternallyField()}
      </div>
    );
  }

  renderHeader() {
    const showTimeStamps = (this.props.createdAt && this.props.updatedAt);
    return (
      <div className="row">
        <div className="col-xs-6">
          <h2 className="no-top-margin">
            <i className="fas fa-cog fa-fw text-primary mr-1"/>
            Settings
          </h2>
        </div>
        {showTimeStamps &&
          <div name="timeLabels" className="col-xs-6 text-right text-muted time-labels">
            <div>
              <small>
                Created {this.props.createdAt}
              </small>
            </div>
            <div>
              <small>
                Updated {this.props.updatedAt}
              </small>
            </div>
          </div>
        }
      </div>
    );
  }

  renderSyndicationHiddenField() {
    return (
      <input name="property[manage_syndication]" type="hidden" value={this.props.syndication ? '1' : '0'} />
    );
  }

  renderHideInternallyField() {
    if (this.props.hideInternally === null) return;

    return (
      <input name="property[hide_internally]" type="hidden" value={this.props.hideInternally ? '1' : '0'} />
    );
  }
}

export default PropertySettings;
